<div class="budget-status"
     [ngClass]="{
       'synced': isBudgetPlanInSync,
       'unsynced': !isBudgetPlanInSync
     }">
  <mat-card class="daxa-card border-radius bg-white border-none budget-summary-card">
    <mat-card-content>
      <div class="status-content">

        <!-- Icon + high-level text -->
        <div class="status-text">
          @if (isBudgetPlanInSync) {
            <mat-icon color="primary">check_circle</mat-icon>
          }
          @if (!isBudgetPlanInSync) {
            <mat-icon color="warn">error</mat-icon>
          }

          @if (isBudgetPlanInSync) {
            <span class="status-ok">Plan proračuna je usklađen</span>
          } @else {
            <span class="status-not-ok">Plan proračuna nije usklađen</span>
          }
        </div>

        <!-- High-level amounts -->
        <div class="status-amounts">
          <!-- Show the main figures the user needs to see -->
          <span>
            <strong>Ukupno traženo (Općina + ostali izvori):</strong>
            {{ totalCostsRequested + totalFundingFromOtherSources | currency:'EUR' }}
          </span>
          <span>
            <strong>Stvarni ukupni troškovi (A+B):</strong>
            {{ totalCostsActual | currency:'EUR' }}
          </span>

          <!-- Show difference details -->
          @if (difference !== 0) {
            <span>
              <strong>Razlika:</strong>
              {{ difference | currency:'EUR' }}
              @if (isShort) {
                (Potrebno još {{ difference | currency:'EUR' }} za pokrivanje troškova)
              }
              @if (isOver) {
                (Traženo je {{ (difference * -1) | currency:'EUR' }} više od stvarnih troškova)
              }
            </span>
          }
        </div>

      </div>
    </mat-card-content>
  </mat-card>
</div>